import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'MatchScoreEdit';

const SELECTOR_PAGE = '.lta-match-score-edit';
const SELECTOR_TRIGGER_EXIT_BUTTON = '.js-exit-score-format-edit-modal';
const SELECTOR_TRIGGER_CANCEL_BUTTON = '.js-cancel-score-format-edit-modal';
const SELECTOR_TRIGGER_SAVE_BUTTON = '.js-save-score-format-edit-modal';


const SELECTOR_MATCH_FORM = '#match-confirmation-score';
const SCORE_FORMAT_SELECT_ELEMEMT = '.js-lta-match-score-select';
const SCORE_FORMAT_TOOLTIP_CONTENT = '.js-lta-tooltip__content';
const SCORE_FORMAT_CONTAINER = '.match-confirmation-score-container';
const SELECTOR_PLAYER1_SET1_INPUT = '#player1-set1-match-score-input';
const SELECTOR_PLAYER2_SET1_INPUT = '#player2-set1-match-score-input';
const SELECTOR_PLAYER1_SET2_INPUT = '#player1-set2-match-score-input';
const SELECTOR_PLAYER2_SET2_INPUT = '#player2-set2-match-score-input';
const SELECTOR_PLAYER1_SET3_INPUT = '#player1-set3-match-score-input';
const SELECTOR_PLAYER2_SET3_INPUT = '#player2-set3-match-score-input';
const SELECTOR_PLAYER1_SET1_TIEBREAK_SET_INPUT	= '#player1-set1-tie-break-match-score-input';
const SELECTOR_PLAYER2_SET1_TIEBREAK_SET_INPUT	= '#player2-set1-tie-break-match-score-input';
const SELECTOR_PLAYER1_SET2_TIEBREAK_SET_INPUT	= '#player1-set2-tie-break-match-score-input';
const SELECTOR_PLAYER2_SET2_TIEBREAK_SET_INPUT	= '#player2-set2-tie-break-match-score-input';
const SELECTOR_PLAYER1_SET3_TIEBREAK_SET_INPUT	= '#player1-set3-tie-break-match-score-input';
const SELECTOR_PLAYER2_SET3_TIEBREAK_SET_INPUT	= '#player2-set3-tie-break-match-score-input';
const SELECTOR_SET2_CONTAINER = '.match-set2-container';
const SELECTOR_SET3_CONTAINER = '.match-set3-container';
const SELECTOR_TIEBREAK_SET1_CONTAINER = '.tie-break-match-set1-container';
const SELECTOR_TIEBREAK_SET2_CONTAINER = '.tie-break-match-set2-container';
const SELECTOR_TIEBREAK_SET3_CONTAINER = '.tie-break-match-set3-container';
const SELECTOR_ERROR_MESSAGE = '.match-score-error';
const SELECTOR_SCORE_TOOLTIP_SELECT = '.match-confirmation-score-tooltip-select';
const SELECTOR_ADD_SET_BUTTON = '.lta-add--match-set';
const SELECTOR_PLAYER1_NAME = '.match-player1-name';
const SELECTOR_PLAYER1_PARTNER_NAME = '.match-player1-partner-name';
const SELECTOR_PLAYER2_NAME = '.match-player2-name';
const SELECTOR_PLAYER2_PARTNER_NAME = '.match-player2-partner-name';

const EVENT_CLICK = `click`;

class MatchScoreEdit extends BaseComponent {

	constructor(element) {
		super(element);
		this.state = {
			scoreData: {},
			player1Name: document.querySelector('.match-player1-name') && document.querySelector('.match-player1-name').innerHTML,
			player2Name: document.querySelector('.match-player2-name') && document.querySelector('.match-player2-name').innerHTML,
			player1PartnerName: document.querySelector('.match-player1-partner-name') && document.querySelector('.match-player1-partner-name').innerHTML,
			player2PartnerName: document.querySelector('.match-player2-partner-name') && document.querySelector('.match-player2-partner-name').innerHTML,
			selectedScoreFormat: '',
			selectedScoreFormatName: '',
			matchScore: '',
			set1Score: '',
			set1TiebreakScore: '',
			set2Score: '',
			set2TiebreakScore: '',
			set3Score: '',
			set3TiebreakScore: '',
			player1Set1Score: '',
			player2Set1Score: '',
			player1Set2Score: '',
			player2Set2Score: '',
			player1Set3Score: '',
			player2Set3Score: '',
			player1Set1TieBreakScore: '',
			player2Set1TieBreakScore: '',
			player1Set2TieBreakScore: '',
			player2Set2TieBreakScore: '',
			player1Set3TieBreakScore: '',
			player2Set3TieBreakScore: '',
			currentSet: 1,
			acceptableSet1Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			acceptableSet1ScoresCondition1: null,
			InputTieBreakSet1Scores: ['7-6', '6-7'],
			acceptableTieBreakScoreS1C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			acceptableTieBreakScoreS1C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			Set2Enabled: false,

			acceptableSet2Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			InputTieBreakSet2Scores: ['7-6', '6-7'],
			acceptableTieBreakScoreS2C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			acceptableTieBreakScoreS2C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			Set3Enabled: false,

			acceptableSet3Scores: ['6-0', '6-1', '6-2', '6-3', '6-4', '7-5', '7-6', '0-6', '1-6', '2-6', '3-6', '4-6', '5-7', '6-7'],
			acceptableSet3ScoresCondition1: null,
			InputTieBreakSet3Scores: ['7-6', '6-7'],
			acceptableTieBreakScoreS3C1: ['7-0', '7-1', '7-2', '7-3', '7-4', '7-5', '0-7', '1-7', '2-7', '3-7', '4-7', '5-7'],
			acceptableTieBreakScoreS3C2: ['Player1-6', 'Player2-6', 'Difference-2'],
			set1Winner: '',
			set2Winner: '',
			set3Winner: '',
			matchWinner: '',
			mappingRules: {
				"3 tie-break sets" : "rule1",
				"2 tie-break sets + match tie-break": "rule2",
				"2 FAST4 sets + match tie-break": "rule3",
				"1 tie-break set": "rule4",
				"1 match tie-break": "rule5",
				"Accept anything": "rule6"
			},
			scoreFormatRules: {
				"rule1": {
					"Name": "3 tie-break sets",
					"description": document.getElementById('rule1') && document.getElementById('rule1').innerHTML,
					"selectedScoreFormat": "3 tie-break sets",
					"acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"acceptableSet1ScoresCondition1": null,
					"InputTieBreakSet1Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set2Enabled": true,
					"acceptableSet2Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"InputTieBreakSet2Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set3Enabled": true,
					"acceptableSet3Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"acceptableSet3ScoresCondition1": null,
					"InputTieBreakSet3Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS3C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS3C2": ["Player1-6", "Player2-6", "Difference-2"]
				},
				"rule2": {
					"Name": "2 tie-break sets + match tie-break",
					"description": document.getElementById('rule2') && document.getElementById('rule2').innerHTML,
					"selectedScoreFormat": "2 tie-break sets + match tie-break",
					"acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"acceptableSet1ScoresCondition1": null,
					"InputTieBreakSet1Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set2Enabled": true,
					"acceptableSet2Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"InputTieBreakSet2Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set3Enabled": true,
					"acceptableSet3Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					"acceptableSet3ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					"InputTieBreakSet3Scores": null,
					"acceptableTieBreakScoreS3C1": null,
					"acceptableTieBreakScoreS3C2": null
				},
				"rule3":
				{
					"Name": "2 FAST4 sets + match tie-break",
					"description": document.getElementById('rule3') && document.getElementById('rule3').innerHTML,
					"selectedScoreFormat": "2 FAST4 sets + match tie-break",
					"acceptableSet1Scores": ["4-0", "4-1", "4-2", "4-3", "0-4", "1-4", "2-4", "3-4"],
					"acceptableSet1ScoresCondition1": null,
					"InputTieBreakSet1Scores": ["4-3", "3-4"],
					"acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set2Enabled": true,
					"acceptableSet2Scores": ["4-0", "4-1", "4-2", "4-3", "0-4", "1-4", "2-4", "3-4"],
					"InputTieBreakSet2Scores": ["4-3", "3-4"],
					"acceptableTieBreakScoreS2C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS2C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set3Enabled": true,
					"acceptableSet3Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					"acceptableSet3ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					"InputTieBreakSet3Scores": null,
					"acceptableTieBreakScoreS3C1": null,
					"acceptableTieBreakScoreS3C2": null
				},
				"rule4": {
					"Name": "1 tie-break set",
					"description": document.getElementById('rule4') && document.getElementById('rule4').innerHTML,
					"selectedScoreFormat": "1 tie-break set",
					"acceptableSet1Scores": ["6-0", "6-1", "6-2", "6-3", "6-4", "7-5", "7-6", "0-6", "1-6", "2-6", "3-6", "4-6", "5-7", "6-7"],
					"acceptableSet1ScoresCondition1": null,
					"InputTieBreakSet1Scores": ["7-6", "6-7"],
					"acceptableTieBreakScoreS1C1": ["7-0", "7-1", "7-2", "7-3", "7-4", "7-5", "0-7", "1-7", "2-7", "3-7", "4-7", "5-7"],
					"acceptableTieBreakScoreS1C2": ["Player1-6", "Player2-6", "Difference-2"],
					"Set2Enabled": false,
					"acceptableSet2Scores": null,
					"InputTieBreakSet2Scores": null,
					"acceptableTieBreakScoreS2C1": null,
					"acceptableTieBreakScoreS2C2": null,
					"Set3Enabled": false,
					"acceptableSet3Scores": null,
					"acceptableSet3ScoresCondition1": null,
					"InputTieBreakSet3Scores": null,
					"acceptableTieBreakScoreS3C1": null,
					"acceptableTieBreakScoreS3C2": null
				},
				"rule5": {
					"Name": "1 match tie-break",
					"description": document.getElementById('rule5') && document.getElementById('rule5').innerHTML,
					"selectedScoreFormat": "1 match tie-break",
					"acceptableSet1Scores": ["10-0", "10-1", "10-2", "10-3", "10-4", "10-5", "10-6", "10-7", "10-8", "8-10", "7-10", "6-10", "5-10", "4-10", "3-10", "2-10", "1-10", "0-10"],
					"acceptableSet1ScoresCondition1": ["Player1-9", "Player2-9", "Difference-2"],
					"InputTieBreakSet1Scores": null,
					"acceptableTieBreakScoreS1C1": null,
					"acceptableTieBreakScoreS1C2": null,
					"Set2Enabled": false,
					"acceptableSet2Scores": null,
					"InputTieBreakSet2Scores": null,
					"acceptableTieBreakScoreS2C1": null,
					"acceptableTieBreakScoreS2C2": null,
					"Set3Enabled": false,
					"acceptableSet3Scores": null,
					"acceptableSet3ScoresCondition1": null,
					"InputTieBreakSet3Scores": null,
					"acceptableTieBreakScoreS3C1": null,
					"acceptableTieBreakScoreS3C2": null
				},
				"rule6": {
					"Name": "Accept anything",
					"description": document.getElementById('rule6') && document.getElementById('rule6').innerHTML,
					"selectedScoreFormat": "Accept anything",
					"acceptableSet1Scores": 'any',
					"acceptableSet1ScoresCondition1": null,
					"InputTieBreakSet1Scores": null,
					"acceptableTieBreakScoreS1C1": null,
					"acceptableTieBreakScoreS1C2": null,
					"Set2Enabled": false,
					"acceptableSet2Scores": null,
					"InputTieBreakSet2Scores": null,
					"acceptableTieBreakScoreS2C1": null,
					"acceptableTieBreakScoreS2C2": null,
					"Set3Enabled": false,
					"acceptableSet3Scores": null,
					"acceptableSet3ScoresCondition1": null,
					"InputTieBreakSet3Scores": null,
					"acceptableTieBreakScoreS3C1": null,
					"acceptableTieBreakScoreS3C2": null
				}
			}
		};
		this._saveCallbacks = [];
		this._cancelCallbacks = [];
		this._matchScoreForm = undefined;
		this._addNewBtn = undefined;
		this._showNextBtn = undefined;
		this._errorContainer = undefined;
		this.init();
	}
	static get NAME() {
		return NAME;
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);

		if (!this._wrapperElement) {
			return;
		}

		this._matchDetailsModalExitButton = SelectorEngine.findOne(SELECTOR_TRIGGER_EXIT_BUTTON, this._wrapperElement);
		this._matchDetailsModalCancelButton = SelectorEngine.findOne(SELECTOR_TRIGGER_CANCEL_BUTTON, this._wrapperElement);

		this._matchDetailsModalsaveButton = SelectorEngine.findOne(SELECTOR_TRIGGER_SAVE_BUTTON, this._wrapperElement);
		
		EventHandler.on(this._matchDetailsModalExitButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));
		EventHandler.on(this._matchDetailsModalCancelButton, EVENT_CLICK , this.onCancelClickHandler.bind(this));

		EventHandler.on(this._matchDetailsModalsaveButton, EVENT_CLICK , this.onSaveClickHandler.bind(this));

		// match score section
		this.matchScoreForm = SelectorEngine.findOne(SELECTOR_MATCH_FORM, this._wrapperElement);
		const scoreFormatElement = SelectorEngine.findOne(SCORE_FORMAT_SELECT_ELEMEMT, this._wrapperElement);
		const scoreFormatTooltipContent = SelectorEngine.findOne(SCORE_FORMAT_TOOLTIP_CONTENT, this._wrapperElement);
		const matchScoreContainer = SelectorEngine.findOne(SCORE_FORMAT_CONTAINER, this._wrapperElement);
		const player1_set1_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET1_INPUT, this._wrapperElement);
		const player2_set1_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET1_INPUT, this._wrapperElement);
		const player1_set2_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET2_INPUT, this._wrapperElement);
		const player2_set2_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET2_INPUT, this._wrapperElement);
		const player1_set3_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET3_INPUT, this._wrapperElement);
		const player2_set3_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET3_INPUT, this._wrapperElement);
		const player1_set1_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET1_TIEBREAK_SET_INPUT, this._wrapperElement);
		const player2_set1_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET1_TIEBREAK_SET_INPUT, this._wrapperElement);
		const player1_set2_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET2_TIEBREAK_SET_INPUT, this._wrapperElement);
		const player2_set2_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET2_TIEBREAK_SET_INPUT, this._wrapperElement);
		const player1_set3_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER1_SET3_TIEBREAK_SET_INPUT, this._wrapperElement);
		const player2_set3_tieBreak_score_input = SelectorEngine.findOne(SELECTOR_PLAYER2_SET3_TIEBREAK_SET_INPUT, this._wrapperElement);
		const set2Container = SelectorEngine.findOne(SELECTOR_SET2_CONTAINER, this._wrapperElement);
		const set3Container = SelectorEngine.findOne(SELECTOR_SET3_CONTAINER, this._wrapperElement);
		const tieBreakSet1Container = SelectorEngine.findOne(SELECTOR_TIEBREAK_SET1_CONTAINER, this._wrapperElement);
		const tieBreakSet2Container = SelectorEngine.findOne(SELECTOR_TIEBREAK_SET2_CONTAINER, this._wrapperElement);
		const tieBreakSet3Container = SelectorEngine.findOne(SELECTOR_TIEBREAK_SET3_CONTAINER, this._wrapperElement);
		this._errorContainer = SelectorEngine.find(SELECTOR_ERROR_MESSAGE,  this._wrapperElement);
		const selectedScoreTooltipContent = SelectorEngine.findOne(SELECTOR_SCORE_TOOLTIP_SELECT, this._wrapperElement);
		this._addNewBtn = SelectorEngine.findOne(SELECTOR_ADD_SET_BUTTON, this._wrapperElement);
		this._showNextBtn = SelectorEngine.findOne(SCORE_FORMAT_CONTAINER, this._wrapperElement).querySelector(SELECTOR_TRIGGER_SAVE_BUTTON);
		this._player1Name = SelectorEngine.findOne(SELECTOR_PLAYER1_NAME, this._wrapperElement);
		this._player1PartnerName = SelectorEngine.findOne(SELECTOR_PLAYER1_PARTNER_NAME, this._wrapperElement);
		this._player2Name = SelectorEngine.findOne(SELECTOR_PLAYER2_NAME, this._wrapperElement);
		this._player2PartnerName = SelectorEngine.findOne(SELECTOR_PLAYER2_PARTNER_NAME, this._wrapperElement);

		// this._player1Name.innerText = this.state.player1Name;
		// this._player2Name.innerText = this.state.player2Name;
		// this._player1PartnerName.innerText = this.state.player1PartnerName;
		// this._player2PartnerName.innerText = this.state.player2PartnerName;

			// this._selectedScoreFormat = document.querySelector('.lta-select__selected').innerText;
			let selectedRuleId = this.state.mappingRules[document.getElementById('existingScoreFormat') && document.getElementById('existingScoreFormat').value];
			this.state.selectedScoreFormatName = this.state.scoreFormatRules[selectedRuleId]?.selectedScoreFormat;
			this.state.selectedScoreFormat = this.state.scoreFormatRules[selectedRuleId]?.Name;
			let description = this.state.scoreFormatRules[selectedRuleId]?.description;
			// document.getElementById('lta-select-items-matchScoreFormat').children.innerHTML = '';
			document.querySelector('.js-lta-match-score-select').querySelector('.lta-select__selected span').innerHTML = this.state.selectedScoreFormat;
			this.showScoreFormatSelectedSection(selectedRuleId);
			if (this.state.selectedScoreFormat !== selectedRuleId) {
				scoreFormatTooltipContent.innerHTML = description;
				player1_set1_score_input.value = '';
				player2_set1_score_input.value = '';
				if (player1_set2_score_input != null) player1_set2_score_input.value = '';
				if (player2_set2_score_input != null) player2_set2_score_input.value = '';
				if (player1_set3_score_input != null) player1_set3_score_input.value = '';
				if (player2_set3_score_input != null) player2_set3_score_input.value = '';
				if (player1_set1_tieBreak_score_input != null) player1_set1_tieBreak_score_input.value = '';
				if (player2_set1_tieBreak_score_input != null) player2_set1_tieBreak_score_input.value = '';
				if (player1_set2_tieBreak_score_input != null) player1_set2_tieBreak_score_input.value = '';
				if (player2_set2_tieBreak_score_input != null) player2_set2_tieBreak_score_input.value = '';
				if (player1_set3_tieBreak_score_input != null) player1_set3_tieBreak_score_input.value = '';
				if (player2_set3_tieBreak_score_input != null) player2_set3_tieBreak_score_input.value = '';
				// matchScoreContainer.querySelector('.js-next-section').classList.add('u-hidden');
				this._addNewBtn.classList.remove('u-hidden');
				set2Container && set2Container.classList.add('u-hidden');
				set3Container && set3Container.classList.add('u-hidden');
				tieBreakSet1Container && tieBreakSet1Container.classList.add('u-hidden');
				tieBreakSet2Container && tieBreakSet2Container.classList.add('u-hidden');
				tieBreakSet3Container && tieBreakSet3Container.classList.add('u-hidden');
			}
			matchScoreContainer.classList.remove('u-hidden');
			selectedScoreTooltipContent.classList.remove('u-hidden');

		EventHandler.on(scoreFormatElement, 'click', (e) => {
			this._errorContainer[0].classList.add('u-hidden');
			this._errorContainer[0].innerText = '';
			this._selectedScoreFormat = e.currentTarget.querySelector('.lta-select__selected').innerText;
			let selectedRuleId = e.currentTarget.querySelector('.lta-select__item--selected').getAttribute('data-ss-id');
			this.state.selectedScoreFormatName = this.state.scoreFormatRules[selectedRuleId].selectedScoreFormat;
			this.showScoreFormatSelectedSection(selectedRuleId);
			let description = this.state.scoreFormatRules[selectedRuleId].description;
			if (this.state.selectedScoreFormat !== selectedRuleId) {
				scoreFormatTooltipContent.innerHTML = description;
				player1_set1_score_input.value = '';
				player2_set1_score_input.value = '';
				if (player1_set2_score_input != null) player1_set2_score_input.value = '';
				if (player2_set2_score_input != null) player2_set2_score_input.value = '';
				if (player1_set3_score_input != null) player1_set3_score_input.value = '';
				if (player2_set3_score_input != null) player2_set3_score_input.value = '';
				if (player1_set1_tieBreak_score_input != null) player1_set1_tieBreak_score_input.value = '';
				if (player2_set1_tieBreak_score_input != null) player2_set1_tieBreak_score_input.value = '';
				if (player1_set2_tieBreak_score_input != null) player1_set2_tieBreak_score_input.value = '';
				if (player2_set2_tieBreak_score_input != null) player2_set2_tieBreak_score_input.value = '';
				if (player1_set3_tieBreak_score_input != null) player1_set3_tieBreak_score_input.value = '';
				if (player2_set3_tieBreak_score_input != null) player2_set3_tieBreak_score_input.value = '';
				// matchScoreContainer.querySelector('.js-next-section').classList.add('u-hidden');
				this._addNewBtn.classList.remove('u-hidden');
				set2Container && set2Container.classList.add('u-hidden');
				set3Container && set3Container.classList.add('u-hidden');
				tieBreakSet1Container && tieBreakSet1Container.classList.add('u-hidden');
				tieBreakSet2Container && tieBreakSet2Container.classList.add('u-hidden');
				tieBreakSet3Container && tieBreakSet3Container.classList.add('u-hidden');
			}
			matchScoreContainer.classList.remove('u-hidden');
			selectedScoreTooltipContent.classList.remove('u-hidden');
		});

		// new function to hide next siblings till the last section and clear input values.
		EventHandler.on(player1_set1_score_input, 'change', (e) => {
			if (this.state.player1Set1Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set2Container, set3Container, tieBreakSet1Container, tieBreakSet2Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.currentSet = 1;
			this.state.player1Set1Score = e.target.value;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set1_score_input, 'change', (e) => {
			if (this.state.player2Set1Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set2Container, set3Container, tieBreakSet1Container, tieBreakSet2Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player2Set1Score = e.target.value;
			this.state.currentSet = 1;
			set2Container.classList.add('u-hidden');
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player1_set2_score_input, 'change', (e) => {
			if (this.state.player1Set2Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [tieBreakSet2Container, set3Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player1Set2Score = e.target.value;
			this.state.currentSet = 2;
			set3Container.classList.add('u-hidden');
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set2_score_input, 'change', (e) => {
			if (this.state.player2Set2Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [tieBreakSet2Container, set3Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player2Set2Score = e.target.value;
			this.state.currentSet = 2;
			set3Container.classList.add('u-hidden');
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player1_set3_score_input, 'change', (e) => {
			if (this.state.player1Set3Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player1Set3Score = e.target.value;
			this.state.currentSet = 3;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set3_score_input, 'change', (e) => {
			if (this.state.player2Set3Score !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player2Set3Score = e.target.value;
			this.state.currentSet = 3;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player1_set1_tieBreak_score_input, 'change', (e) => {
			if (this.state.player1Set1TieBreakScore !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set2Container, set3Container, tieBreakSet2Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);

			}
			this.state.player1Set1TieBreakScore = e.target.value;
			this.state.currentSet = 1;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set1_tieBreak_score_input, 'change', (e) => {
			if (this.state.player2Set1TieBreakScore !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set2Container, set3Container, tieBreakSet2Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player2Set1TieBreakScore = e.target.value;
			this.state.currentSet = 1;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player1_set2_tieBreak_score_input, 'change', (e) => {
			if (this.state.player1Set2TieBreakScore !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set3Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player1Set2TieBreakScore = e.target.value;
			this.state.currentSet = 2;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set2_tieBreak_score_input, 'change', (e) => {
			if (this.state.player2Set2TieBreakScore !== e.target.value) {
				// Hiding next sets if current set score is changed.
				let setArr = [set3Container, tieBreakSet3Container];
				this.hideContainersAndClearValues(setArr);
			}
			this.state.player2Set2TieBreakScore = e.target.value;
			this.state.currentSet = 2;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player1_set3_tieBreak_score_input, 'change', (e) => {
			this.state.player1Set3TieBreakScore = e.target.value;
			this.state.currentSet = 3;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});

		EventHandler.on(player2_set3_tieBreak_score_input, 'change', (e) => {
			this.state.player2Set3TieBreakScore = e.target.value;
			this.state.currentSet = 3;
			this._addNewBtn.classList.remove('u-hidden');
			this._showNextBtn.classList.add('u-hidden');
		});


		EventHandler.on(this._addNewBtn, 'click', (e) => {
				if (this.state.currentSet == 1) {
					this.matchSetCalculator(Number(this.state.player1Set1Score), Number(this.state.player2Set1Score), Number(this.state.player1Set1TieBreakScore), Number(this.state.player2Set1TieBreakScore), this.state.acceptableSet1Scores, this.state.acceptableSet1ScoresCondition1, this.state.InputTieBreakSet1Scores, this.state.acceptableTieBreakScoreS1C1, this.state.acceptableTieBreakScoreS1C2, this.state.Set2Enabled, tieBreakSet1Container, this.state.currentSet, set2Container, player1_set1_score_input, player2_set1_score_input, player1_set1_tieBreak_score_input, player2_set1_tieBreak_score_input);
				} else if (this.state.currentSet == 2) {
					this.matchSetCalculator(Number(this.state.player1Set2Score), Number(this.state.player2Set2Score), Number(this.state.player1Set2TieBreakScore), Number(this.state.player2Set2TieBreakScore), this.state.acceptableSet2Scores, this.state.acceptableSet2ScoresCondition1, this.state.InputTieBreakSet2Scores, this.state.acceptableTieBreakScoreS2C1, this.state.acceptableTieBreakScoreS2C2, this.state.Set3Enabled, tieBreakSet2Container, this.state.currentSet, set3Container, player1_set2_score_input, player2_set2_score_input, player1_set2_tieBreak_score_input, player2_set2_tieBreak_score_input);
				} else if (this.state.currentSet == 3) {
					this.matchSetCalculator(Number(this.state.player1Set3Score), Number(this.state.player2Set3Score), Number(this.state.player1Set3TieBreakScore), Number(this.state.player2Set3TieBreakScore), this.state.acceptableSet3Scores, this.state.acceptableSet3ScoresCondition1, this.state.InputTieBreakSet3Scores, this.state.acceptableTieBreakScoreS3C1, this.state.acceptableTieBreakScoreS3C2, false, tieBreakSet3Container, this.state.currentSet, null, player1_set3_score_input, player2_set3_score_input, player1_set3_tieBreak_score_input, player2_set3_tieBreak_score_input);
				}
		});
	}

	showScoreFormatSelectedSection(selectedScoreFormat) {
		switch (selectedScoreFormat) {
			case "rule1":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule1.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule1.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule1.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule1.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule1.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule1.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule1.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule1.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule1.acceptableTieBreakScoreS3C2;
				break;

			case "rule2":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule2.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule2.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule2.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule2.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule2.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule2.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule2.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule2.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule2.acceptableTieBreakScoreS3C2;
				break;

			case "rule3":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule3.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule3.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule3.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule3.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule3.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule3.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule3.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule3.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule3.acceptableTieBreakScoreS3C2;
				break;

			case "rule4":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule4.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule4.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule4.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule4.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule4.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule4.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule4.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule4.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule4.acceptableTieBreakScoreS3C2;
				break;

			case "rule5":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule5.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule5.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule5.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule5.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule5.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule5.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule5.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule5.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule5.acceptableTieBreakScoreS3C2;
				break;

			case "rule6":
				this.state.acceptableSet1Scores = this.state.scoreFormatRules.rule6.acceptableSet1Scores;
				this.state.acceptableSet1ScoresCondition1 = this.state.scoreFormatRules.rule6.acceptableSet1ScoresCondition1;
				this.state.InputTieBreakSet1Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet1Scores;
				this.state.acceptableTieBreakScoreS1C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS1C1;
				this.state.acceptableTieBreakScoreS1C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS1C2;
				this.state.Set2Enabled = this.state.scoreFormatRules.rule6.Set2Enabled;

				this.state.acceptableSet2Scores = this.state.scoreFormatRules.rule6.acceptableSet2Scores;
				this.state.InputTieBreakSet2Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet2Scores;
				this.state.acceptableTieBreakScoreS2C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS2C1;
				this.state.acceptableTieBreakScoreS2C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS2C2;
				this.state.Set3Enabled = this.state.scoreFormatRules.rule6.Set3Enabled;

				this.state.acceptableSet3Scores = this.state.scoreFormatRules.rule6.acceptableSet3Scores;
				this.state.acceptableSet3ScoresCondition1 = this.state.scoreFormatRules.rule6.acceptableSet3ScoresCondition1;
				this.state.InputTieBreakSet3Scores = this.state.scoreFormatRules.rule6.InputTieBreakSet3Scores;
				this.state.acceptableTieBreakScoreS3C1 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS3C1;
				this.state.acceptableTieBreakScoreS3C2 = this.state.scoreFormatRules.rule6.acceptableTieBreakScoreS3C2;
				break;
		}
	}

	hideContainersAndClearValues(setArr) {
		setArr && setArr.map(i => {
			i && i.classList.add('u-hidden');
			i.querySelectorAll("input")[0].value = '';
			i.querySelectorAll("input")[1].value = '';
		});
	}

	matchSetCalculator(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore, acceptableSetScores, acceptableSetScoresC1, InputTieBreakSetScores, acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, nextSetEnabled, tieBreakSetContainer, currentSet, setContainer, player1_set_score_input, player2_set_score_input, player1_set_tieBreak_score_input, player2_set_tieBreak_score_input) {

		if (!this.validateScores(player1_set_score_input, player2_set_score_input)) {
			this._errorContainer[0].classList.remove('u-hidden');
			this._errorContainer[0].innerText = 'Validate Scores error';
			return;
		} else {
			this._errorContainer[0].classList.add('u-hidden');
			this._errorContainer[0].innerText = '';
		}

		let setScore = player1SetScore + '-' + player2SetScore;
		this.saveSetScore(setScore, currentSet);

		if ((acceptableSetScores !== null && acceptableSetScores.includes(setScore)) || (acceptableSetScoresC1 !== null && !acceptableSetScores.includes(setScore))) {
			//Check for additional acceptable set score condition if exist
			if (acceptableSetScoresC1 !== null && !acceptableSetScores.includes(setScore)) {
				if (!this.calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableSetScoresC1, player1SetScore, player2SetScore)) {
					this._errorContainer[0].classList.remove('u-hidden');
					this._errorContainer[0].innerText = ' This score doesnt look right – please try again';
					return;
				} else {
					this._errorContainer[0].classList.add('u-hidden');
				}
			}
			if (InputTieBreakSetScores !== null) {
				// Check if Tie break condition is applicable
				if (InputTieBreakSetScores.includes(setScore)) {

					// Check if tie break set 1 is already visible
					if (!tieBreakSetContainer.classList.contains('u-hidden')) {
						if (!this.validateScores(player1_set_tieBreak_score_input, player2_set_tieBreak_score_input)) {
							this._errorContainer[0].classList.remove('u-hidden');
							this._errorContainer[0].innerText = 'Validate tie break scores error';
							return;
						} else {
							this._errorContainer[0].classList.add('u-hidden');
							this._errorContainer[0].innerText = '';
						}
						// Check for invalid tie break score
						if (!this.validateWithCurrentSetScores(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore)) {
							this._errorContainer[0].classList.remove('u-hidden');
							this._errorContainer[0].innerText = 'Invalid tie break scores';
							return;
						} else {
							this._errorContainer[0].classList.add('u-hidden');
							this._errorContainer[0].innerText = '';
						}
						let currentSetTieBreakScore = player1SetTieBreakScore + '-' + player2SetTieBreakScore;
						this.saveTieBreakScore(currentSetTieBreakScore, currentSet);
						if (this.customAcceptableTieBreakConditions(acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore)) {
							this._errorContainer[0].classList.add('u-hidden');
							this._errorContainer[0].innerText = '';
							this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
							this.decideNextStep(currentSet, setContainer, nextSetEnabled);
						} else {
							// Check if scores are not as per acceptable formats
							this._errorContainer[0].classList.remove('u-hidden');
							this._errorContainer[0].innerText = 'Invalid tie break scores';
						}
					} else {
						// Check if current tie break set is hidden
						tieBreakSetContainer.classList.remove('u-hidden');
					}
					
				} else {
					this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				}
			} else {
				// Declare Match Winner for first to 10 points & Different Format.
				this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
				this.decideNextStep(currentSet, setContainer, nextSetEnabled);
			}
		} else {
			// For any score format
			this._errorContainer[0].classList.add('u-hidden');
			this._errorContainer[0].innerText = '';
			if(acceptableSetScores == 'any') {
				if(player1SetScore > player2SetScore) {
					this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				} else if (player2SetScore > player1SetScore) {
					this.decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled);
					this.decideNextStep(currentSet, setContainer, nextSetEnabled);
				}
			} else {
				// Check if scores are not as per acceptable formats
				this._errorContainer[0].classList.remove('u-hidden');
				this._errorContainer[0].innerText = ' This score doesnt look right – please try again';
			}
			
		}
	}

	saveSetScore(setScore, currentSet) {
		switch(currentSet.toString()) {
			case "1":
				this.state.set1Score = setScore;
				break;
			case "2":
				this.state.set2Score = setScore;
				break;
			case "3":
				this.state.set3Score = setScore;
				break;
		}
	}

	saveTieBreakScore(currentSetTieBreakScore, currentSet) {
		switch(currentSet.toString()) {
			case "1":
				this.state.set1TiebreakScore = currentSetTieBreakScore;
				break;
			case "2":
				this.state.set2TiebreakScore = currentSetTieBreakScore;
				break;
			case "3":
				this.state.set3TiebreakScore = currentSetTieBreakScore;
				break;
		}
	}


	validateWithCurrentSetScores(player1SetScore, player2SetScore, player1SetTieBreakScore, player2SetTieBreakScore) {
		if((player1SetScore > player2SetScore) && (player1SetTieBreakScore > player2SetTieBreakScore)) {
			return true;
		} else if((player2SetScore > player1SetScore) && (player2SetTieBreakScore > player1SetTieBreakScore)) {
			return true;
		}
		return false;
	}

	calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableSetScoresCondition, player1SetScore, player2SetScore) {
		let player1Limit, player2Limit, difference;
		if(acceptableSetScoresCondition) {
			player1Limit = Number(acceptableSetScoresCondition[0].split('-')[1]);
			player2Limit = Number(acceptableSetScoresCondition[0].split('-')[1]);
			difference = Number(acceptableSetScoresCondition[2].split('-')[1]);
			if (player1SetScore >= player1Limit && player2SetScore >= player2Limit) {
				if (player1SetScore > player2SetScore && player1SetScore - player2SetScore == difference) {
					return true;
				}
				if (player2SetScore > player1SetScore && player2SetScore - player1SetScore == difference) {
					return true;
				}
			}
		}
		return false;
	}


	customAcceptableTieBreakConditions(acceptableTieBreakScoreC1, acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore) {
		if (acceptableTieBreakScoreC1.includes(player1SetTieBreakScore + '-' + player2SetTieBreakScore)) {
			return true;
		}
		return this.calculateCustomPlayerScoreGreaterThanValueAndDifference(acceptableTieBreakScoreC2, player1SetTieBreakScore, player2SetTieBreakScore);
	}

	decideNextStep(currentSet, setContainer, nextSetEnabled) {
		switch(currentSet.toString()) {
			case "1":
				if(nextSetEnabled) {
					setContainer.classList.remove('u-hidden');
					this.state.currentSet = currentSet + 1;
					this.hideNextButton(this._showNextBtn);
				} else {
					this.showNextButton(this._showNextBtn, this._addNewBtn);
				}
				break;
			case "2":
				if(this.state.set1Winner == this.state.set2Winner) {
					this.showNextButton(this._showNextBtn, this._addNewBtn);
				} else if(nextSetEnabled) {
					setContainer.classList.remove('u-hidden');
					this.state.currentSet = currentSet + 1;
					this.hideNextButton(this._showNextBtn);
				} else {
					this.showNextButton(this._showNextBtn, this._addNewBtn);
				}
				break;
			case "3":
				this.showNextButton(this._showNextBtn, this._addNewBtn);
				break;
		}
	}

	showNextButton(showNextBtn, addNewBtn) {
		addNewBtn.classList.add('u-hidden');
		showNextBtn.classList.remove('u-hidden');
	}

	hideNextButton(showNextBtn) {
		!showNextBtn.classList.contains('u-hidden') && showNextBtn.classList.add('u-hidden');
	}

	decideSetWinner(player1SetScore, player2SetScore, currentSet, nextSetEnabled) {
		let setWinner;
		if ((player1SetScore - player2SetScore) >= 1) {
			setWinner = "team1";
		} else {
			setWinner = "team2";
		}
		if (currentSet == 1) {
			this.state.set1Winner = setWinner;
			console.log("Set 1 Winner" + ": " + this.state.set1Winner);
			if (!nextSetEnabled) {
				this.state.matchWinner = this.state.set1Winner;
			}
		} else if (currentSet == 2) {
			this.state.set2Winner = setWinner;
			console.log("Set 2 Winner" + ": " + this.state.set2Winner);
			if (this.state.set2Winner == this.state.set1Winner) {
				this.state.matchWinner = this.state.set2Winner;
			}
		} else if (currentSet == 3) {
			this.state.set3Winner = setWinner;
			console.log("Set 3 Winner" + ": " + this.state.set3Winner);
			if (this.state.set1Winner == this.state.set3Winner) {
				this.state.matchWinner = this.state.set3Winner;
			} else if (this.state.set2Winner == this.state.set3Winner) {
				this.state.matchWinner = this.state.set3Winner;
			}
		}
	}

	validateScores(player1_set_score_input, player2_set_score_input) {
		if (player1_set_score_input.value == '') {
			if (player1_set_score_input != null) {
				player1_set_score_input.focus();
				this._showNextBtn.classList.add('u-hidden');
				return false;
			}
		}
		if (player2_set_score_input.value == '') {
			if (player2_set_score_input != null) {
				player2_set_score_input.focus();
				this._showNextBtn.classList.add('u-hidden');
				return false;
			}
		}
		return true;
	}


	onCancel(callback){
		this._cancelCallbacks.push(callback);
	}

	onCancelClickHandler(){
		for (const callback of this._cancelCallbacks) {
			callback();
		}
	}

	onSave(callback) {
		this._saveCallbacks.push(callback);
	}

	onSaveClickHandler() {
		this.state.scoreData["player1Name"] = this.state.player1Name;
		this.state.scoreData["player2Name"] = this.state.player2Name; 
		this.state.scoreData["player1PartnerName"] = this.state.player1PartnerName; 
		this.state.scoreData["player2PartnerName"] = this.state.player2PartnerName; 
		this.state.scoreData["set1Player1Score"] = this.state.player1Set1Score; 
		document.getElementById('matchscoreTeam1Set1_updated').value = this.state.player1Set1Score;

		this.state.scoreData["set1Player2Score"] = this.state.player2Set1Score;
		document.getElementById('matchscoreTeam2Set1_updated').value = this.state.player2Set1Score;

		this.state.scoreData["set2Player1Score"] = this.state.player1Set2Score; 
		document.getElementById('matchscoreTeam1Set2_updated').value = this.state.player1Set2Score;

		this.state.scoreData["set2Player2Score"] = this.state.player2Set2Score;
		document.getElementById('matchscoreTeam2Set2_updated').value = this.state.player2Set2Score;

		this.state.scoreData["set3Player1Score"] = this.state.player1Set3Score; 
		document.getElementById('matchscoreTeam1Set3_updated').value = this.state.player1Set3Score;

		this.state.scoreData["set3Player2Score"] = this.state.player2Set3Score; 
		document.getElementById('matchscoreTeam2Set3_updated').value = this.state.player2Set3Score;

		this.state.scoreData["set1Player1TieBreakScore"] = this.state.player1Set1TieBreakScore; 
		document.getElementById('matchscoreTeam1Set1Tiebreak_updated').value = this.state.player1Set1TieBreakScore;

		this.state.scoreData["set1Player2TieBreakScore"] = this.state.player2Set1TieBreakScore;
		document.getElementById('matchscoreTeam2Set1Tiebreak_updated').value = this.state.player2Set1TieBreakScore;

		this.state.scoreData["set2Player1TieBreakScore"] = this.state.player1Set2TieBreakScore;
		document.getElementById('matchscoreTeam1Set2Tiebreak_updated').value = this.state.player1Set2TieBreakScore;

		this.state.scoreData["set2Player2TieBreakScore"] = this.state.player2Set2TieBreakScore;
		document.getElementById('matchscoreTeam2Set2Tiebreak_updated').value = this.state.player2Set2TieBreakScore;

		this.state.scoreData["set3Player1TieBreakScore"] = this.state.player1Set3TieBreakScore; 
		document.getElementById('matchscoreTeam1Set3Tiebreak_updated').value = this.state.player1Set3TieBreakScore;

		this.state.scoreData["set3Player2TieBreakScore"] = this.state.player2Set3TieBreakScore;
		document.getElementById('matchscoreTeam2Set3Tiebreak_updated').value = this.state.player2Set3TieBreakScore;

		this.state.scoreData["matchWinner"] = this.state.matchWinner;
		document.getElementById('winner_updated').value = this.state.matchWinner;
		document.getElementById('score_updated').value = this.state.selectedScoreFormatName;

		for (const callback of this._saveCallbacks) {
			callback(this.state.scoreData);
		}
		document.getElementById('confirm-result').classList.add('u-hidden');
		document.getElementById('dispute-result').classList.remove('u-hidden');
	}
}

export default MatchScoreEdit;
